/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */
import { Injectable, NgZone } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { FancyActionTrackerFactory } from 'src/app/common/fancy-firebase/services/fancy-action-tracker-factory.service';
import { RefOrObservable } from '../../fancy-firebase/base/interfaces';
import { FancyFirebaseSplitDataListFactory } from '../../fancy-firebase/services/factories';
import { LoggerServiceFactory } from '../../logging/LoggerServiceFactory';

// TicketList
// -----------------------------------------------------------------------------
import { TicketList } from '../lists/TicketList';
export * from '../lists/TicketList';

@Injectable({
	providedIn: 'root',
})
export class TicketListFactory extends FancyFirebaseSplitDataListFactory {
	constructor(
		protected db: AngularFireDatabase,
		protected fancyActionTrackerFactory: FancyActionTrackerFactory,
		protected ngZone: NgZone
	) {
		super(db, fancyActionTrackerFactory);

		this.extraAngulars = { ngZone: this.ngZone };
	}
	public create(path: RefOrObservable, fancyJoins?, additionalDependencies?: any[]): TicketList {
		return super.create(TicketList, path, fancyJoins, additionalDependencies);
	}
}
